export function copyToClipboard(stringToCopy: string) {
	const textArea = document.createElement('textarea');
	textArea.value = stringToCopy;
	document.body.appendChild(textArea);
	textArea.select();
	document.execCommand('Copy');
	document.body.removeChild(textArea);
}
